export const getMinutesSince = (date: string) => {
  // Backend sends UTC timestamps without timezone indicator, so append 'Z' if missing
  const utcDate = date.endsWith('Z') ? date : `${date}Z`;
  return Math.ceil((Date.now() - new Date(utcDate).getTime()) / 60_000);
};
